export default __webpack_public_path__ + "fa40db0b647f6b74c84e053ff8b0e50d.svg";